import { Box, Card, CardContent, Typography, TextField, Button, Dialog, DialogContent, DialogActions, Checkbox, FormControlLabel, ListItemText, Snackbar } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import React, { useState, useEffect } from 'react'
import Header from '../../components/Header'
import { DesktopTimePicker, MobileDatePicker, MobileTimePicker } from '@mui/x-date-pickers';
import { collection, setDoc, doc, getDocs, deleteDoc} from 'firebase/firestore';
import { db } from '../../firebase';
import "./Activity.css"
import { useLocation, useNavigate } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';
import enAU from 'date-fns/locale/en-AU';
import MuiAlert from '@mui/material/Alert';

class Error {
	constructor() {
		this.error = false;
		this.reason = "";
	}
}

class Errors {
	constructor() {
		let errors = ["date", "type", "hour", "area", "action", "weed", "chemical", "time", "volume", "rate", "wind"];
		errors.forEach((error) => { this[error] = new Error() });
	}
}

export default function Activity() {
	let [errors, setErrors] = useState( new Errors());

	const [edit,setEdit] = useState(true);

	const validateDate = (set) =>
	{
		let field = "date";
		if (date.length === 0) {
			errors[field].error = true;
			errors[field].reason = "Date cannot be blank";
		} else {
			errors[field].error = false;
			errors[field].reason = "";
		}
		if (set) {
			setErrors({ ...errors });
		}
	}
	const validateType = (set) => {
		let field = "type";
		if (type.length === 0) {
			errors[field].error = true;
			errors[field].reason = "Type cannot be blank";
		} else {
			errors[field] = new Error();
		}
		if (set) {
			setErrors({ ...errors });
		}
	}
	const validateHour = (set) => {
		let field = "hour";
		if (hour.length === 0) {
			errors[field].error = true;
			errors[field].reason = "Hour cannot be blank";
		} else {
			errors[field] = new Error();
		}
		if (set) {
			setErrors({ ...errors });
		}
	}
	const validateArea = (set) => {
		let field = "area";
		if (area.length === 0) {
			errors[field].error = true;
			errors[field].reason = "Area cannot be blank";
		} else {
			errors[field] = new Error();
		}
		if (set) {
			setErrors({ ...errors });
		}
	}
	const validateAction = (set) => {
		let field = "action";
		if (action.length === 0) {
			errors[field].error = true;
			errors[field].reason = "Action cannot be blank";
		} else {
			errors[field] = new Error();
		}
		if (set) {
			setErrors({ ...errors });
		}
	}
	const validateWeed = (set) => {
		let field = "weed";
		if (weed.length === 0) {
			errors[field].error = true;
			errors[field].reason = "Weed cannot be blank";
		} else {
			errors[field] = new Error();
		}
		if (set) {
			setErrors({ ...errors });
		}
	}
	const validateChemical = (set) => {
		let field = "chemical";
		if (chemical.length === 0) {
			errors[field].error = true;
			errors[field].reason = "Chemical cannot be blank";
		} else {
			errors[field] = new Error();
		}
		if (set) {
			setErrors({ ...errors });
		}
	}
	const validateTime = (set) => {
		let field = "time";
		if (time.length === 0) {
			errors[field].error = true;
			errors[field].reason = "Time cannot be blank";
		} else {
			errors[field] = new Error();
		}
		if (set) {
			setErrors({ ...errors });
		}
	}
	const validateVolume = (set) => {
		let field = "volume";
		if (volume.length === 0) {
			errors[field].error = true;
			errors[field].reason = "Volume cannot be blank";
		} else {
			errors[field] = new Error();
		}
		if (set) {
			setErrors({ ...errors });
		}
	}
	const validateRate = (set) => {
		let field = "rate";
		if (rate.length === 0) {
			errors[field].error = true;
			errors[field].reason = "Rate cannot be blank";
		} else {
			errors[field] = new Error();
		}
		if (set) {
			setErrors({ ...errors });
		}
	}
	const validateWind = (set) => {
		let field = "wind";
		if (wind.length === 0) {
			errors[field].error = true;
			errors[field].reason = "Wind cannot be blank";
		} else {
			errors[field] = new Error();
		}
		if (set) {
			setErrors({ ...errors });
		}
	}
	const validateAll = function () {
		errors = new Errors();
		validateDate();
		validateType();
		validateHour();
		validateArea();
		validateAction();
		validateWeed();
		if(chems)
		{
			validateChemical();
			validateTime();
			validateVolume();
			validateRate();
			validateWind();
		}
		setErrors(errors);
	}

	// Weeds list
	const [weeds, setWeeds] = useState([])
	const [actions, setActions] = useState([])
	const [chemicals, setChemicals] = useState([])
	const [types, setTypes] = useState([])

	// Date
	const [date, setDate] = useState("")
	const [dateRender, setDateRender] = useState(null)  // this exists solely for the input field to display the selected date
	const onDateChange = e => {
		let newDate = e;
		//console.log(e);
		if(newDate == null)
		{
			setDate("");
			return;
		}
		setDateRender(newDate);
		let month = newDate.getMonth() + 1;
		let stringDate = `${('0' + newDate.getDate()).slice(-2)}-${('0' + month).slice(-2)}-${newDate.getFullYear()}`;
		setDate(stringDate);
	};

	// type
	const [type, setType] = useState("")
	const handleTypeChange = e => setType(e.target.value)

	// action
	const [action, setAction] = useState("")
	const handleActionChange = e => {
		if (actions.find((act) => { return act.name === e.target.value }).chemical === true) {
			setChems(true);
		} else {
			setChems(false);
			setChemical("");
			setTime("");
			setTimeRender(null);
			setVolume("");
			setRate("");
			setWind("");
		}
		setAction(e.target.value);
	}

	// weed
	const [weed, setWeed] = useState([])
	const handleWeedChange = e => {
		setWeed(e.target.value);
		//validateWeed(true);
	}

	// chemical
	const [chemical, setChemical] = useState("")
	const handleChemicalChange = e => setChemical(e.target.value)

	// time
	const [time, setTime] = useState("")
	const [timeRender, setTimeRender] = useState(null)  // this exists solely for the input field to display the selected time
	const handleTimeChange = (newTime) => {
		if(newTime==null)
		{
			setTime("");
			setTimeRender("");
			return;
		}
		setTimeRender(newTime);
		let stringTime = `${('0'+newTime.getHours()).slice(-2)}:${('0'+newTime.getMinutes()).slice(-2)}`;
		setTime(stringTime);
	}


	// hour
	const [hour, setHour] = useState("")
	const handleHourChange = e => {
		let val = e.target.value;
		const min = 0;
		const max = 24;
		if (val < min) {
			e.target.value = min;
		} else if (val > max) {
			e.target.value = max;
		}
		setHour(e.target.value);
	}

	// area
	const [area, setArea] = useState("")
	const onAreaChange = e => {
		const min = 0;
		const max = 20000;
		if (e.target.value < min) {
			e.target.value = min;
		} else if (e.target.value > max) {
			e.target.value = max;
		}
		setArea(e.target.value);
	}

	// other
	const [other, setOther] = useState("")
	const onOtherChange = e => setOther(e.target.value)

	// comment
	const [comment, setComment] = useState("")
	const onCommentChange = e => setComment(e.target.value)

	// volume
	const [volume, setVolume] = useState("")
	const onVolumeChange = e => {
		const min = 0;
		const max = 100000;
		if (e.target.value < min) {
			e.target.value = min;
		} else if (e.target.value > max) {
			e.target.value = max;
		}
		setVolume(e.target.value);
	}

	// rate
	const [rate, setRate] = useState("")
	const onRateChange = e => {
		if (e.target.value < 0) {
			e.target.value = 0;
		} else if (e.target.value > 100) {
			e.target.value = 100;
		}
		setRate(e.target.value);
	}

	// wind
	const [wind, setWind] = useState("")
	const onWindChange = e => setWind(e.target.value)

	// signage
	const [signage, setSignage] = useState(true);
	const onSignageChange = e => setSignage(e.target.checked)

	// Project and Zone
	const {project="" , zone=""} = useLocation().state;
	const [project_,setProject] = useState(project);
	const [zone_,setZone] = useState(zone);

	// name
	const genName = function () {
		var act = "";
		if (action.length > 0) {
			act = "_" + actions.find((act) => { return act.name === action }).id;
		}
		var date2 = "";
		if (date.length > 0) {
			date2 = "_" + date;
		}
		return project_ + "_" + zone_ + act + date2;
	};
	const updateName = function () {
		setName(genName());
	}
	const [name, setName] = useState("");
	//const onNameChange = e => setName(e.target.value)

	useEffect(
		() => {
			updateName();
		}, [action, date]
	);

	// navigate
	const navigate = useNavigate()

	const [dataLoaded,setDataLoaded] = useState(false);
	
	const getData = () => {
		let count = 0;
		if(weeds.length === 0)
		{
			const weedsRef = collection(db, "Weeds")
			getDocs(weedsRef).then(
			  snapshot => {
				const tmp = snapshot.docs.map(
				  doc => {
					return { id: doc.id, ...doc.data() }
				  }
				)
				setWeeds(tmp)
				count++;
				if(count===4)
				{
					setDataLoaded(true);
				}
				console.log("got weeds");
			  }
			).catch(
				err => console.log(err)
			)
		}
		if (actions.length === 0) {
			const actionsRef = collection(db, "Actions")
			getDocs(actionsRef).then(
			  snapshot => {
				const tmp = snapshot.docs.map(
				  doc => {
					return { id: doc.id, ...doc.data() }
				  }
				)
				setActions(tmp)
				count++;
				if(count===4)
				{
					setDataLoaded(true);
				}
				console.log("got actions");
			  }
			).catch(
				err => console.log(err)
			)
		}

		if (types.length === 0) {
			const chemicalsRef = collection(db, "Chemicals")
			getDocs(chemicalsRef).then(
			  snapshot => {
				const tmp = snapshot.docs.map(
				  doc => {
					return { id: doc.id, ...doc.data() }
				  }
				)
				setChemicals(tmp)
				count++;
				if(count===4)
				{
					setDataLoaded(true);
				}
				console.log("got chemicals");
			  }
			).catch(
				err => console.log(err)
			)
		}

		if (types.length === 0) {
			const typesRef = collection(db, "Types")
			getDocs(typesRef).then(
			  snapshot => {
				const tmp = snapshot.docs.map(
				  doc => {
					return { id: doc.id, ...doc.data() }
				  }
				)
				setTypes(tmp);
				count++;
				if(count===4)
				{
					setDataLoaded(true);
				}
				console.log("got types");
			  }
			).catch(
				err => console.log(err)
			)
		}
	}

	const [chems, setChems] = useState(false);


	let location = useLocation();
	//console.log(location);
	const report = location.state.report;

	const {isAdmin = false} = location.state;

	const [timeStamp,setTimeStamp] = useState(null);

	const loadDataFromReport = (r)=>
	{
		//setName(r.name);
		setProject(r.project);
		setZone(r.zone);
		setDate(r.date);
		const datet = r.date.split("-");
		setDateRender(new Date(datet[2],datet[1],datet[0]));
		setType(r.type);
		setHour(r.hour);
		setArea(r.area);
		setAction(r.action);
		setWeed(r.weed.split(", "));
		setOther(r.other);
		setComment(r.comment);
		if(r.chemical !== "")
		{
			setChems(true);
		}
		setChemical(r.chemical);
		setSignage(deStringBool(r.signage));
		setTime(r.time);
		let timet = new Date();
		const tempt = r.time.split(":");
		timet.setHours(tempt[0],tempt[1]);
		setTimeRender(timet);
		setVolume(r.volume);
		setRate(r.rate);
		setWind(r.wind);
		setTimeStamp(r.timeStamp);
		setEdit(false);
	}

	useEffect(
		() => {
			if(dataLoaded)
			{
				if(report)
				{
					loadDataFromReport(report);
				}
			}
		}, [dataLoaded]
	);

	// Stuff to do on first load
	useEffect(
		() => {
			getData();
			if(report==null)
			{
				updateName();
			}
		}, []
	)

	const onClickSubmitButton = () => {
		let timeStampz = timeStamp;
		console.log(timeStampz);
		if(timeStampz == null)
		{
			const today = new Date();
			timeStampz = `${today.getDate()}-${today.getMonth()+1}-${today.getFullYear()}-${today.getHours()}:${today.getMinutes()}:${today.getSeconds()}`;
		}
		
		const activityRef = doc(db, "Activity", name + " " + timeStampz);
		if(report)
		{deleteDoc(doc(db,"Activity",report.id));}
		let weed2 = weed.join(", ");

		setDoc(activityRef, { project: project_, zone: zone_, date, type, hour, area, action, weed:weed2 , other, comment, chemical, signage:signage.toString(), time, volume, rate, wind, timeStamp:timeStampz }).then(
			response => {
				console.log(response)
				navigate("/")
			}
		).catch(
			err => console.log(err)
		);
	}

	const inputValidation = () => {
		let errorS = "";
		validateAll();
		for (const error in errors) {
			let reason = errors[error].reason;
			if(reason.length !== 0)
			{
				//makeError(reason);
				errorS+= reason + ". ";
			}
		}
		
		return errorS
	}

	const onClickResetButton = () => {
		// TODO: reset
		//console.log("foo");
		navigate("/home");
	}

	// dialog
	const [open, setOpen] = useState(false)
	const handleClickOpen = () => {
		let inVal = inputValidation();
		if (inVal.length === 0)
			setOpen(true)
		else {

			//ToDo: Error popup
			console.log(inVal)
			makeError(inVal);
			//window.alert(inVal)
		}

	}
	const handleCancel = () => setOpen(false)

	//const user = useSelector(selectUser);

	var width = "50%";
	var mobile = false;

	if (!useMediaQuery('(min-width:600px)')) {
		width = "100%";
		mobile = true;
	}

	const [errorReason,setErrorReason] = useState("");
	const [openErrorSnack, setOpenErrorSnack] = useState(false);
	const handleErrorSnackClose = ()=>
	{
		setErrorReason("");
		setOpenErrorSnack(false);
	}

	const makeError = (reason)=>{
		setErrorReason(reason);
		setOpenErrorSnack(true);
	}

	const onEditModeChange = (e)=>
	{
		setEdit(e.target.checked);
	}

	//console.log(signage);

	const deStringBool = (b)=>
	{
		if(b==="true")
		{
			return true;
		}
		return false;
	}


	return (
		<div id='activity-form'>
			<Header title="Activity" />
			<Snackbar open={openErrorSnack} autoHideDuration={5000} onClose={handleErrorSnackClose} anchorOrigin={{ vertical:"top", horizontal:"center" }}>
				<MuiAlert variant="filled" severity="error">
					{errorReason}
				</MuiAlert>
			</Snackbar>
			<LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enAU}>
			<Box sx={{ display: "flex", flexDirection: "column", p: 1, m: 1, justifyContent: "center", alignItems: "center" }}>
				{/* <Card sx={{ width: width, p: 1, m: 1 }}>
					<CardContent>
						<Typography variant="h3" component="div" gutterBottom>
							Report Activity
						</Typography>
					</CardContent>
				</Card> */}

				<Card sx={{ width: width, p: 1, m: 1 }}>
					<CardContent>
						<Typography variant="subtitle1" gutterBottom component="div">
							Project:
						</Typography>
						<TextField variant="filled" fullWidth value={project_} InputProps={{
							readOnly: true,
						}} />
						<Typography variant="subtitle1" sx={{ marginTop:"20px"}} gutterBottom component="div">
							Zone:
						</Typography>
						<TextField variant="filled" fullWidth value={zone_} InputProps={{
							readOnly: true,
						}} />
						<Typography variant="subtitle1" sx={{ marginTop:"20px"}} gutterBottom component="div">
							Date:
						</Typography>
						<FormControl sx={{ minWidth: 250 }} fullWidth>
							{!mobile ? <DatePicker
								value={dateRender}
								onChange={onDateChange}
								renderInput={(params) => <TextField {...params} 
								error={errors.date.error}/>}
								readOnly={!edit}
							/>:
							<MobileDatePicker
								value={dateRender}
								onChange={onDateChange}
								renderInput={(params) => <TextField {...params} 
								error={errors.date.error}/>}
								readOnly={!edit}
							/>
							}
						</FormControl>
						{isAdmin?
						<FormControlLabel
							control={<Checkbox/>} 
							label="Edit Mode:"
							labelPlacement="start" 
							onChange={onEditModeChange}
							sx={{ marginTop:"20px"}}
						/>
						:null}
					</CardContent>
				</Card>
				
				<Card sx={{ width: width, p: 1, m: 1 }}>
					<CardContent>
						<FormControl sx={{ minWidth: 250 }} fullWidth error={errors.type.error}>
							<InputLabel>Type</InputLabel>
							<Select
								value={type}
								label="Type"
								onChange={handleTypeChange}
								readOnly={!edit}
							>
								{
									types.map((type, idx) => <MenuItem key={idx} value={type.name}>{type.name}</MenuItem>)
								}
							</Select>
						</FormControl>
						<TextField variant="outlined" fullWidth sx={{ marginTop:"20px"}} type="number" onChange={handleHourChange} error={errors.hour.error} label="Hours" value={hour} InputProps={{readOnly: !edit}}/>
						<TextField variant="outlined" fullWidth sx={{ marginTop:"20px"}} type="number" onChange={onAreaChange} error={errors.area.error} label="Area (m²)" value={area} InputProps={{readOnly: !edit}}/>
						<FormControl sx={{ minWidth: 250, marginTop: "20px" }} fullWidth error={errors.action.error}>
							<InputLabel>Action</InputLabel>
							<Select
								value={action}
								label="Action"
								onChange={handleActionChange}
								readOnly={!edit}
							>
								{actions.map((action, idx) => <MenuItem key={idx} value={action.name}>{action.name}</MenuItem>)}
							</Select>
						</FormControl>
						<FormControl sx={{ minWidth: 250, marginTop: "20px" }} fullWidth error={errors.weed.error}>
							<InputLabel>Weeds</InputLabel>
							<Select
								value={weed}
								label="Weeds"
								multiple
								onChange={handleWeedChange}
								renderValue={(selected) => selected.join(", ")}
								readOnly={!edit}
							>
								{weeds.map((weedd, idx) => 
									<MenuItem key={idx} value={weedd.name}>
										<Checkbox checked={weed.indexOf(weedd.name) > -1}/>
										<ListItemText primary={weedd.name}/>
									</MenuItem>
								)}
							</Select>
						</FormControl>
						<TextField variant="outlined" fullWidth sx={{ marginTop:"20px"}} onChange={onOtherChange} label="Other" value={other} InputProps={{readOnly: !edit}}/>
						<TextField variant="outlined" fullWidth sx={{ marginTop:"20px"}} onChange={onCommentChange} label="Comment" value={comment} InputProps={{readOnly: !edit}}/>
					</CardContent>
				</Card>
				
				<Card sx={{ width: width, p: 1, m: 1 }}>
					<CardContent>
						<FormControl sx={{ minWidth: 250, marginBottom: "20px" }} fullWidth disabled={!chems} error={errors.chemical.error}>
							<InputLabel>Chemicals</InputLabel>
							<Select
								value={chemical}
								label="Chemical"
								onChange={handleChemicalChange}
								readOnly={!edit}
							>
								{chemicals.map((chemical, idx) => <MenuItem key={idx} value={chemical.name}>{chemical.name}</MenuItem>)}
							</Select>
						</FormControl>
						
						<Box sx={{ display: 'flex', justifyContent: 'space-around', marginTop: "20px" }} >
							{!mobile?<DesktopTimePicker
								label="Time"
								value={timeRender}
								disabled={!chems}
								onChange={handleTimeChange}
								renderInput={(params) => <TextField {...params} 
								error={errors.time.error}/>}
								readOnly={!edit}
							/>:
							<MobileTimePicker
								label="Time"
								value={timeRender}
								disabled={!chems}
								onChange={handleTimeChange}
								renderInput={(params) => <TextField {...params} 
								error={errors.time.error}/>}
								readOnly={!edit}
							/>
							}
							<FormControlLabel
								disabled={!chems || !edit}
								control={<Checkbox disabled={!edit} checked={signage}/>}
								label="Notification:"
								labelPlacement="start" 
								onChange={onSignageChange}
								readOnly={!edit}
							/>
						</Box>
						<TextField type="number" variant="outlined" fullWidth sx={{ marginTop:"20px"}} onChange={onVolumeChange} error={errors.volume.error} label="Volume (mL)" disabled={!chems} value={volume} InputProps={{readOnly: !edit}}/>
						<TextField type="number" variant="outlined" fullWidth sx={{ marginTop:"20px"}} onChange={onRateChange} error={errors.rate.error} label="Rate %" disabled={!chems} value={rate} InputProps={{readOnly: !edit}}/>
						<TextField variant="outlined" fullWidth sx={{ marginTop:"20px",marginBottom: "20px" }} onChange={onWindChange} error={errors.wind.error} label="Wind" disabled={!chems} value={wind} InputProps={{readOnly: !edit}}/>
					</CardContent>
				</Card>
				
				<Card sx={{ width: width, p: 1, m: 1 }}>
					<CardContent>
						<Box display={"flex"} justifyContent={"space-around"}>
							<Button variant="outlined" onClick={onClickResetButton}>Cancel</Button>
							{report==null||isAdmin?<Button variant="contained" onClick={handleClickOpen} disabled={!edit}>Submit</Button>:null}
							<Dialog
								open={open}
								onClose={handleCancel}
							>
								<DialogContent>
									Are you sure you want to submit the report?
								</DialogContent>
								<DialogActions>
									<Button onClick={handleCancel}>Cancel</Button>
									<Button onClick={onClickSubmitButton} autoFocus>Submit</Button>
								</DialogActions>
							</Dialog>
						</Box>
					</CardContent>
				</Card>
			</Box>
			</LocalizationProvider>
		</div>
	);
}
